import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { auth } from '../../Firebase/firebase';
import { userService } from '../../../_services';
import './NavBarFinal.css';

const NavBarFinal = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [user, setUser] = useState(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const menuRef = useRef(null);
    const toggleRef = useRef(null);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const res = await userService.getInfo();
                setUser(res);
            } catch (error) {
                console.error('Error fetching user info:', error);
            }
        };

        const updatePushToken = async () => {
            try {
                await userService.updatePushToken();
            } catch (error) {
                console.error('Error updating push token:', error);
            }
        };

        fetchUser();
        updatePushToken();

        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                toggleRef.current &&
                !toggleRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const logoutHandler = () => {
        try {
            localStorage.removeItem("user");
            auth.signOut();
            navigate("/Login");
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    const toggleMenu = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
            <div className="navbar-container">
                <div className="navbar-left">
                    <span className="welcome-text">
                        {t('welcome', { username: user?.name || '' })}
                    </span>
                </div>

                <div className={`mobile-menu-wrapper ${isOpen ? 'active' : ''}`} ref={menuRef}>
                    <div className="navbar-center">
                        <NavLink to="/home/code" className="nav-link" onClick={() => setIsOpen(false)}>
                            {t('home')}
                        </NavLink>
                        <NavLink to="/home/dailyHistoryFinal" className="nav-link" onClick={() => setIsOpen(false)}>
                            {t('daily')}
                        </NavLink>
                        <NavLink to="/home/monthlyHistoryFinal" className="nav-link" onClick={() => setIsOpen(false)}>
                            {t('monthly')}
                        </NavLink>
                        <NavLink to="/home/ManageClubs" className="nav-link" onClick={() => setIsOpen(false)}>
                            {t('manageClub')}
                        </NavLink>
                    </div>

                    <div className="navbar-right">
                        <button className="logout-button" onClick={logoutHandler}>
                            {t('logout')}
                        </button>
                    </div>
                </div>

                <div className="desktop-navbar-center">
                    <NavLink to="/home/code" className="nav-link">
                        {t('home')}
                    </NavLink>
                    <NavLink to="/home/dailyHistoryFinal" className="nav-link">
                        {t('daily')}
                    </NavLink>
                    <NavLink to="/home/monthlyHistoryFinal" className="nav-link">
                        {t('monthly')}
                    </NavLink>
                    <NavLink to="/home/ManageClubs" className="nav-link">
                        {t('manageClub')}
                    </NavLink>
                </div>

                <div className="desktop-navbar-right">
                    <button className="logout-button" onClick={logoutHandler}>
                        {t('logout')}
                    </button>
                </div>

                <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu" ref={toggleRef}>
                    <span className={`hamburger ${isOpen ? 'open' : ''}`}></span>
                </button>
            </div>
        </nav>
    );
};

export default NavBarFinal;
